
<template>
	<div id="measurement-schedule-form" ref="measurementForm" class="panel p-2">
		<button class="button is-primary" @click="addRoutine">
			<span class="icon is-small">
				<i class="fas fa-plus"></i>
			</span>
			<span>Agregar</span>
		</button>
		<div v-for="(sch, i) in schedules" :key="'sch-form-' + i">
			<div class="select is-primary">
				<select @input="onHourInput($event, sch)">
					<option disabled>HH</option>
					<option v-for="(h, i) in 24" :key="'h' + i">
						{{ formatTimeValue(h - 1) }}
					</option>
				</select>
			</div>
			<div class="select is-primary mx-2">
				<select @input="onMinuteInput($event, sch)">
					<option disabled>MM</option>
					<option v-for="(mm, i) in 12" :key="'mm' + i">
						{{ formatTimeValue((mm - 1) * 5) }}
					</option>
				</select>
			</div>

			<button class="button is-danger" @click="removeRoutine(i)">
				<span class="icon is-small">
					<i class="fas fa-minus"></i>
				</span>
			</button>
		</div>
		<div>
			<button class="button" @click="submitUpdate">Actualizar Rutina</button>
		</div>
	</div>
</template>


<script lang="ts">
	import { RoutineMeasurement } from "@/domain/entities/EntityFields";
	import { pprint } from "@/helpers/pprint";
	import useDoctor from "@/store/DoctorState";
	import { defineComponent, ref } from "vue";

	export default defineComponent({
		setup() {
			const DEFAULT_VALUE_TIME = "00";
			let schedules = ref<RoutineMeasurement[]>([{ takeMeasureTime: "00:00" }]);
			const measurementForm = ref(null);
			const cleanSelects = () => {
				(measurementForm.value! as HTMLElement)
					.querySelectorAll("select")
					.forEach((s) => (s.value = DEFAULT_VALUE_TIME));
				schedules.value.length = 1
			};
			const { updateMeasurementSchedule } = useDoctor();
			const formatTimeValue = (t: string | number): string => {
				if (typeof t == "number") t = t.toString();
				return t.padStart(2, "0");
			};
			const addRoutine = () => {
				schedules.value.push({ takeMeasureTime: "00:00" });
			};
			const removeRoutine = (i: number) => {
				schedules.value.splice(i, 1);
			};
			const onHourInput = (ev: Event, mr: RoutineMeasurement) => {
				pprint("ev", ev);
				let value = (ev.target as HTMLInputElement).value;
				mr.takeMeasureTime = mr.takeMeasureTime.replace(/^(\d{2})/, value);
			};
			const onMinuteInput = (ev: Event, mr: RoutineMeasurement) => {
				pprint("ev", ev);
				let value = (ev.target as HTMLInputElement).value;
				mr.takeMeasureTime = mr.takeMeasureTime.replace(/(\d{2})$/, value);
			};
			const submitUpdate = async () => {
				pprint("schedules", schedules.value);
				try {
					await updateMeasurementSchedule(schedules.value);
					cleanSelects();
				} catch (err) {
					console.error(err);
				}
			};

			return {
				schedules,
				addRoutine,
				removeRoutine,
				submitUpdate,
				onMinuteInput,
				onHourInput,
				formatTimeValue,
				measurementForm,
			};
		},
	});
</script>

<style lang="stylus" scoped>
	.select-group > div {
		display: inline-block;
	}
</style>